import { Component, OnInit } from '@angular/core';
import { ServiceLayer } from '../../../services/serviceLayer';
import { DAO } from '../../../modal/DAO';

@Component({
  selector: 'app-policy-details',
  templateUrl: './policy-details.component.html',
  styleUrls: ['./policy-details.component.css']
})
export class PolicyDetailsComponent implements OnInit {

  constructor(public serviceLayer : ServiceLayer, public dao :DAO) { }
  public PolicyDetailsList : any;
  public mettaDateType : string = 'All';
  public isEditControls: any={};

  ngOnInit(): void {
    this.getPolicyTabDetails();
  }
  //===========get policy details==================
  async getPolicyTabDetails(){
    this.PolicyDetailsList =  await this.serviceLayer.getPolicyTabDetails(this.dao.referenceNumber,this.mettaDateType);
  }
  //==============show the control when click the edit icon===========
  editTheDetails(controlName) {
    this.isEditControls[controlName] = true;
    if(controlName=="PolicyPeriod"){
      this.PolicyDetailsList.policyStartDate=new Date(this.PolicyDetailsList.policyStartDate); 
      this.PolicyDetailsList.policyEndDate=new Date(this.PolicyDetailsList.policyEndDate); 
    }
  }
  //=============Show lable from control view===============
  skipEdit(controlName) {
    this.isEditControls[controlName] = false;
  }
  //=============Show lable from all control view===============
  skipAllEdit(){
    this.isEditControls= [];
  }
}
